import React from 'react';

const Underwriting = () => {
  return (
    <iframe
      src="https://v2-embednotion.com/Underwriting-c44e478eb85e4369ba6fa0ab07f26c74"
      title="Underwriting"
      style={{
        width: '100%',
        height: '600px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        padding: 'none',
        boxShadow: '0 2px 2px #ccc '
      }}
    />
  );
};

export default Underwriting;
